module.exports = __webpack_public_path__ + "media/stylesheets/images/consulting-1-cfd3f49e73217af9d763576d4e69cd11.jpg";